import RouteContent from "./RouteContent";
import React, {useContext, useEffect} from "react";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";
import {ROUTE_INFO_METRIC_KEY} from "../util/MetricUtil";
import RouteInfo from "./RouteInfo";

const RouteDetailView = (props) => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)

    useEffect(() => {
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({type: 'GET_CAPABILITIES', data: model});
            configDispatch({
                type: 'GET_STATION_CONFIG',
                data: {
                    dispatcher: configDispatch,
                    baseUrl: model.baseUrl,
                    metricKey: ROUTE_INFO_METRIC_KEY
                }
            });
        })
    }, []);

    return (
        <div>
            {configViewModel.capability !== '' && configViewModel.stationConfig.initialised ?
                <div>
                    <RouteInfo history={props.history} route={props.route}/>
                    <RouteContent/>
                </div>
                : null

            }
        </div>
    )
}

export default RouteDetailView


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/RouteDetailView.js